export const womenFootwears = [
    {   
        id: 0,
        name: 'Korean black',
        price: 12.99,
        image: './asset/women-footwear1.png'
    },   
    {
        id: 1,
        name: 'Sperry vibe',
        price: 12.99,
        image: './asset/women-footwear2.png'
    },
    {
        id: 2,
        name: 'Running shoes',
        price: 14.99,
        image: './asset/women-footwear3.png'
    },
    {
        id: 3,
        name: 'Keds fashion',
        price: 12.99,
        image: './asset/women-footwear4.png'
    },
    {
        id: 4,
        name: 'Halfshoes',
        price: 12.99,
        image: './asset/women-footwear5.png'
    },
    {
        id: 5,
        name: 'Joyride running',
        price: 17.99,
        image: './asset/women-footwear6.png'
    },
    {
        id: 6,
        name: 'Korean gold',
        price: 12.99,
        image: './asset/women-footwear8.png'
    },
    {
        id: 7,
        name: 'Lace half',
        price: 12.99,
        image: './asset/women-footwear9.png'
    },
    {
        id: 8,
        name: 'Pink half',
        price: 12.99,
        image: './asset/women-footwear10.png'
    },
    {
        id: 9,
        name: 'Twinkle black',
        price: 14.99,
        image: './asset/women-footwear12.png'
    },
    {
        id: 10,
        name: 'Twinkle gold',
        price: 14.99,
        image: './asset/women-footwear13.png'
    },
    {
        id: 11,
        name: 'Office sandals',
        price: 14.99,
        image: './asset/women-footwear14.png'
    },

    ]